import React from 'react';
export function CampaignDraftIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M13 13H7v-2h6v2zm-6 4h10v-2H7v2z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.039 1a2 2 0 011.561.75l2.962 3.702A2 2 0 0121 6.702V23H3V1h13.039zM19 21H5V3h8v6h6v12zm0-14v-.298L16.039 3H15v4h4z"
  }));
}